


const Logo=({onClick})=>{
  

    return(

        <div className="logo" onClick={onClick}>
                <div>
                <h1 className="task">TaskRanger</h1>
                </div>
                        <div className="management">
                        <p>TASK</p><p>MANAGEMENT</p><p>APPLICATION</p>
                        </div>
       </div> 
    )
}

export default Logo


